import React from "react";
import {
  CHART_TYPE_AREA,
  CHART_TYPE_CANDLES,
  CHART_TYPE_BARS,
  CHART_TYPE_HEIKIN_ASHI,
} from "../../../constants";

const VIEW_BOX = "0 0 24 24";
const DEFAULT_STROKE_WIDTH = 1.5;
const AREA_FILL_OPACITY = 0.25;

// Shared baseline under every chart type, as in the PO menu.
const BASELINE = <path d="M3 20h18" />;

const LINE_POINTS = "M4 16l4-5 4 3 4-5 4-3";

const LINE_SHAPE = (
  <>
    <path
      d={`${LINE_POINTS}V17H4z`}
      fill="currentColor"
      fillOpacity={AREA_FILL_OPACITY}
      stroke="none"
    />
    <path d={LINE_POINTS} />
  </>
);

const CANDLES_SHAPE = (
  <>
    <path d="M6 5v3M6 13v3M12 3v3M12 11v3M18 6v3M18 14v2" />
    <rect x="4.5" y="8" width="3" height="5" rx="0.5" />
    <rect x="10.5" y="6" width="3" height="5" rx="0.5" />
    <rect x="16.5" y="9" width="3" height="5" rx="0.5" />
  </>
);

// OHLC bars: open tick on the left, close tick on the right.
const BARS_SHAPE = (
  <path d="M6 6v10M4 9h2M6 13h2M12 4v11M10 12h2M12 7h2M18 7v10M16 10h2M18 14h2" />
);

// Heikin Ashi: candles with upper shadows only.
const HEIKIN_ASHI_SHAPE = (
  <>
    <path d="M6 5v3M12 3v3M18 6v3" />
    <rect x="4.5" y="8" width="3" height="6" rx="0.5" />
    <rect x="10.5" y="6" width="3" height="6" rx="0.5" />
    <rect x="16.5" y="9" width="3" height="6" rx="0.5" />
  </>
);

const SHAPES = {
  [CHART_TYPE_AREA]: LINE_SHAPE,
  [CHART_TYPE_CANDLES]: CANDLES_SHAPE,
  [CHART_TYPE_BARS]: BARS_SHAPE,
  [CHART_TYPE_HEIKIN_ASHI]: HEIKIN_ASHI_SHAPE,
};

/**
 * Icon for a chart type (Line / Candles / Bars / Heikin Ashi).
 * Drawn in the lucide style: stroke-based, uses currentColor.
 *
 * @param {object} props
 * @param {number} props.type   - SeriesType value
 * @param {number} props.size   - width and height in px
 * @param {number} [props.strokeWidth]
 */
const ChartTypeIcon = ({ type, size, strokeWidth = DEFAULT_STROKE_WIDTH }) => (
  <svg
    width={size}
    height={size}
    viewBox={VIEW_BOX}
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {BASELINE}
    {SHAPES[type] ?? CANDLES_SHAPE}
  </svg>
);

export default ChartTypeIcon;
